import type { BreadcrumbItem } from '@bv/components/breadcrumb/BvBreadcrumbs.vue';

/**
 * Creates a reusable breadcrumb generator function that prepends base (parent) breadcrumb items
 * to any child breadcrumb items passed to it.
 *
 * @param MainItems - The base breadcrumb items (e.g. root section / module level).
 * @returns A function that accepts additional child breadcrumb items and returns the combined array of breadcrumbs.
 *
 * @example
 * ```ts
 * const settingsBreadcrumbs = generateBreadcrumbs({
 *   label: 'settings.settings',
 *   route: { name: 'settings' }
 * });
 *
 * // Generates: [{ label: 'settings.settings', route: { name: 'settings' } }, { label: 'settings.nav.users', route: { name: 'usersList' } }]
 * const usersBreadcrumbs = settingsBreadcrumbs({
 *   label: 'settings.nav.users',
 *   route: { name: 'usersList' }
 * });
 * ```
 */
export const generateBreadcrumbs =
  (...MainItems: BreadcrumbItem[]): ((...items: BreadcrumbItem[]) => BreadcrumbItem[]) =>
  (...items: BreadcrumbItem[]): BreadcrumbItem[] => [...MainItems, ...items];
